import { Group } from '@mantine/core';
import { IconBrandInstagram, IconBrandLinkedin, IconBrandX, IconBrandYoutubeFilled } from '@tabler/icons-react';

export default function SocialBrands({ color }) {
  return (
    <>
      <a href="http://instagram.com/hisselitapucom" target="_blank" rel="noreferrer">
        <Group bg={'rgba(0,0,0,0.4)'} style={{ borderRadius: '5px' }} p={5} w={40} h={40} align={'center'} justify={'center'}>
          <IconBrandInstagram color={color ? color : 'var(--color-dim)'} stroke={2} size={25} />
        </Group>
      </a>
      <a href="http://linkedin.com/company/hisselitapu" target="_blank" rel="noreferrer">
        <Group bg={'rgba(0,0,0,0.4)'} style={{ borderRadius: '5px' }} p={5} w={40} h={40} align={'center'} justify={'center'}>
          <IconBrandLinkedin color={color ? color : 'var(--color-dim)'} stroke={2} size={25} />
        </Group>
      </a>
      <a href="http://x.com/hisselitapu" target="_blank" rel="noreferrer">
        <Group bg={'rgba(0,0,0,0.4)'} style={{ borderRadius: '5px' }} p={5} w={40} h={40} align={'center'} justify={'center'}>
          <IconBrandX color={color ? color : 'var(--color-dim)'} stroke={2} size={25} />
        </Group>
      </a>
      <a href="http://youtube.com/@hisselitapu" target="_blank" rel="noreferrer">
        <Group bg={'rgba(0,0,0,0.4)'} style={{ borderRadius: '5px' }} p={5} w={40} h={40} align={'center'} justify={'center'}>
          <IconBrandYoutubeFilled color={color ? color : 'var(--color-dim)'} stroke={2} size={22} />
        </Group>
      </a>
    </>
  );
}
